/* Lightweight forward geocode (Mapbox Geocoding v6) — returns the top match as a
 * flat shape: { full, address, city, state, zip, country, lng, lat }.
 * Degrades to null if no token / no match (so callers can skip silently). */
const TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || "";
const ENDPOINT = "https://api.mapbox.com/search/geocode/v6/forward";

export async function geocodeAddress(q, countries = "us") {
    if (!TOKEN || !q || q.trim().length < 4) return null;
    try {
        const url = `${ENDPOINT}?q=${encodeURIComponent(q)}&country=${countries}&limit=1&access_token=${TOKEN}`;
        const r = await fetch(url);
        const d = await r.json();
        const f = (d.features || [])[0];
        if (!f || !f.properties) return null;
        const p = f.properties;
        const ctx = p.context || {};
        const c = (f.geometry && f.geometry.coordinates) || [];
        return {
            full: p.full_address || p.name || q,
            address: p.name || p.full_address || q,
            city: ctx.place?.name || ctx.locality?.name || "",
            state: ctx.region?.region_code || ctx.region?.name || "",
            zip: ctx.postcode?.name || "",
            country: ctx.country?.country_code || ctx.country?.name || "",
            lng: c[0],
            lat: c[1],
        };
    } catch {
        return null;
    }
}
